<template>
    <div class="com-course-item" @click="clickItem">
        <div class="com-course-item-img">
            <img v-lazy="courseData.f_pic" />
        </div>
        <div class="com-course-item-content">
            <h3 class="com-course-item-title">{{ courseData.f_title }}</h3>
            <div class="com-course-item-info">{{ courseData.f_details }}</div>
            <div class="com-course-item-detail">
                <span class="course-price price-red" v-if="courseData.payPrice > 0">￥<span class="price-num">{{ courseData.payPrice }}</span></span>
                <span class="course-free-paid" v-for="fText in courseData.freePaidList" :key="fText">{{ fText }}</span>
                <span v-if="courseData.gotPaid" class="course-paid">已购买</span>
                <span class="course-price-origin line-through">￥<span class="price-num">{{ courseData.ratePrice }}</span></span>
                <span class="course-price-free" v-for="fText in courseData.freeList" :key="fText">{{ fText }}</span>
                <span class="course-sold-numbers">{{ courseData.times }}人购买</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CourseListItem',
    props: {
        courseData: {
            type: Object,
            default() { return {} }
        }
    },
    computed: {
        userVip() {
            return this.$store.state.userData && this.$store.state.userData.info ? this.$store.state.userData.info.vip : 0;
        },
    },
    data() {
        return {
            locked: false
        }
    },
    methods:{
        clickItem() {
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, 1000);
            this.$store.dispatch('course/getCourseTableList', {
                cid: this.courseData.id,
                vip: this.userVip,
                sucCb: ()=> {
                    this.$router.replace('/coursedetail/'+this.courseData.id);
                }
            })
        }
    }
}
</script>
